// Memory only: restore earlier answers on active-poll changes without a read.
// A new entry/session/participant gets an empty cache; retain at most 100 polls.
const caches = new WeakMap()
const LIMIT = 100

export function pollResponseScope(state) {
  return JSON.stringify([state.audienceEntryGeneration || 0, state.session?.code || '', state.session?.id || '',
    state.participantId || '', state.participantToken || ''])
}

function scopedCache(state) {
  const scope = pollResponseScope(state)
  let cache = caches.get(state)
  if (!cache || cache.scope !== scope) {
    cache = { scope, responses: new Map() }
    caches.set(state, cache)
  }
  return cache
}

export function rememberPollResponse(state, id, response, expectedScope = pollResponseScope(state)) {
  if (!id || expectedScope !== pollResponseScope(state)) return false
  const cache = scopedCache(state)
  const selectedOptionIds = Array.isArray(response?.selectedOptionIds) ? response.selectedOptionIds.map(String).slice(0, 50) : []
  const responseText = String(response?.responseText || '').slice(0, 500)
  cache.responses.delete(String(id))
  if (response?.responded === true || selectedOptionIds.length > 0 || responseText) {
    cache.responses.set(String(id), { selectedOptionIds, responseText, responded: true })
    while (cache.responses.size > LIMIT) cache.responses.delete(cache.responses.keys().next().value)
  }
  return true
}

export function rememberCurrentPollResponse(state) {
  if (caches.has(state) && caches.get(state).scope !== pollResponseScope(state)) { scopedCache(state); return }
  if (state.poll?.responded) rememberPollResponse(state, state.poll.id, state.poll)
}

export function clearOwnPollResponses(state) { caches.delete(state) }

export function readPollResponse(state, id) {
  const cache = scopedCache(state)
  const response = cache.responses.get(String(id))
  if (!response) return null
  cache.responses.delete(String(id)); cache.responses.set(String(id), response)
  return { ...response, selectedOptionIds: [...response.selectedOptionIds] }
}
